module.exports = __webpack_public_path__ + "static/img/left-home-row-2.d0d7360a.png";